<template>
  <div class="w-full mt-4">
    <LeaderboardTable
      :entries="entries"
      :loading="leaderboardLoading"
      :current-user-id="currentUserId"
      period-label="for achievements"
      empty-text="No achievements unlocked yet."/>
  </div>
</template>
<script setup>

import {computed, onMounted} from "vue";
import LeaderboardTable from "./LeaderboardTable.vue";
import {useAchievements} from "../composables/useAchievements.js";

const {loadAchievementLeaderboard, leaderboard, leaderboardLoading} = useAchievements();

const currentUserId = localStorage.getItem('userId') || '';

onMounted(() => {
  loadAchievementLeaderboard();
})

const entries = computed(() => leaderboard.value.map(r => ({
  id: r.id,
  name: r.name,
  verified: r.verified,
  valueDisplay: `${r.count} 🏅`
})));

</script>


<style scoped>

</style>
